import React, { useEffect, useState } from 'react';
import { useModals } from '../../../../../contexts/ModalsContext';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../../../../modal/PropdocsModal';
import styles from './styles.module.scss';
import { useNavigation } from '../../../../../contexts/NavigationContext';

interface PlaceholderWarningModalProps {
  isOpen: boolean;
  placeholders: number;
  onReview?: () => void;
  onContinue: () => void;
  onHide?: () => void;
  modalTitle?: string;
  continueButtonText?: string;
  reviewButtonText?: string;
}

const PlaceholderWarningModal: React.FC<PlaceholderWarningModalProps> = ({
  isOpen = false,
  placeholders,
  onReview,
  onContinue,
  onHide,
  modalTitle = 'Placeholders',
  continueButtonText = 'Continue Anyways',
  reviewButtonText = 'Review',
}) => {
  const { setClosePendingWarningReviewModal } = useModals();
  const {
    sidenavPlaceholdersCollapsed: isPlaceholderSidenavCollapsed,
    setActiveSidenavPlaceholder,
    toggleSidenavPlaceholdersCollapsed,
  } = useNavigation();

  const [showPlaceholderWarningModal, setShowPlaceholderWarningModal] = useState(isOpen);

  const [collapsePlaceholderSidenav, setCollapsePlaceholderSidenav] = useState(isPlaceholderSidenavCollapsed);

  const handleReview = () => {
    setShowPlaceholderWarningModal(false);

    if (onReview) {
      onReview();
    }

    setActiveSidenavPlaceholder(null);

    setClosePendingWarningReviewModal(true);

    if (collapsePlaceholderSidenav) {
      toggleSidenavPlaceholdersCollapsed(false);
    }
  };

  const handleContinue = () => {
    setShowPlaceholderWarningModal(false);
    onContinue();
  };

  useEffect(() => {
    setShowPlaceholderWarningModal(isOpen);
  }, [isOpen]);

  useEffect(() => {
    setCollapsePlaceholderSidenav(isPlaceholderSidenavCollapsed);
  }, [isPlaceholderSidenavCollapsed]);

  return (
    <PropdocsModal
      size="md"
      className={styles.placeholderWarningModal}
      title=<div className={styles.placeholderWarningModal__header}>{modalTitle}</div>
      show={showPlaceholderWarningModal}
      setShow={() => {
        setShowPlaceholderWarningModal(!showPlaceholderWarningModal);

        if (onHide) {
          onHide();
        }
      }}
    >
      <>
        <div className={styles.placeholderWarningModal__title}>
          There are {placeholders} incomplete required placeholders
        </div>
        <div className={styles.placeholderWarningModal__buttonsContainer}>
          <Button className={styles.placeholderWarningModal__buttonReview} variant="secondary" onClick={handleReview}>
            {reviewButtonText}
          </Button>
          <Button onClick={handleContinue} className={styles.placeholderWarningModal__buttonContinue}>
            {continueButtonText}
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};

export default PlaceholderWarningModal;
